import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check agar user ne pehle se consent diya hua hai
    const consent = localStorage.getItem("sevaa_cookie_consent");
    
    // Agar nahi diya hai, toh website load hone ke 1.5 seconds baad popup dikhao
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("sevaa_cookie_consent", "accepted");
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("sevaa_cookie_consent", "rejected");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, x: -50 }} // Bottom-Left se smooth slide hoke aayega
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.5, type: "spring", stiffness: 200, damping: 20 }}
          // Fixed position corner me set karne ke liye
          className="fixed bottom-6 left-6 z-[999] max-w-[400px] bg-white p-6 md:p-8 rounded-2xl shadow-2xl border border-slate-100 font-poppins"
        >
          <h3 className="text-xl font-black text-slate-900 mb-3">
            We value your privacy
          </h3>
          <p className="text-[13px] text-slate-500 mb-6 leading-relaxed font-medium">
            We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
          </p>
          
          {/* Buttons Layout exactly like your image */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button 
              onClick={() => setIsVisible(false)} // Temporary close
              className="flex-1 px-4 py-3 text-xs font-bold text-[#0f766e] border-2 border-[#0f766e] rounded-xl hover:bg-[#0f766e]/5 transition-colors"
            >
              Customize
            </button>
            <button 
              onClick={handleReject}
              className="flex-1 px-4 py-3 text-xs font-bold text-[#0f766e] border-2 border-[#0f766e] rounded-xl hover:bg-[#0f766e]/5 transition-colors"
            >
              Reject All
            </button>
            <button 
              onClick={handleAccept}
              className="flex-1 px-4 py-3 text-xs font-bold text-white bg-[#0f766e] border-2 border-[#0f766e] rounded-xl hover:bg-slate-900 hover:border-slate-900 transition-colors shadow-lg shadow-teal-500/30"
            >
              Accept All
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;